// extracted by mini-css-extract-plugin
export default {"descriptionText":"fboFI","resetPasswordInvalidContainer":"Oy92i"};